module.exports = __webpack_public_path__ + "static/media/blueMapMarker.4c870d4a.png";